export const getConfigIndex = (items, id) => {
	return items.findIndex(item => item.id === id);
};

export const isConfigItemVisible = (items, id) => {
	const configItem = items && items.find(item => item.id === id);

	return configItem && !configItem.hidden;
};
